import { DynamicStandaloneAffiliateItem } from '@/components/AffiliateItem';
import { LabradorComponent } from '@/types/component';
import { mapLabradorImageToStandaloneImage } from '@/utils/image';
import withDebugMetadata from '@/utils/withDebugMetadata';
import type { AffiliateItemProduct } from 'base/components/AffiliateItem';
import { findAllOfType } from 'lib/labrador/content-operations/findBy';

const LabradorAffiliateItem: LabradorComponent = ({ type, data, meta, descendants }) => {
  const labradorImages = findAllOfType(descendants, 'labradorImage');

  const products = data.products?.map((product: AffiliateItemProduct, index: number) => ({
    image: mapLabradorImageToStandaloneImage(labradorImages[index]),
    ...product,
  }));

  return (
    <DynamicStandaloneAffiliateItem
      counter={
        meta.affiliateItemPosition &&
        meta.affiliateItemsTotal &&
        `${meta.affiliateItemPosition}/${meta.affiliateItemsTotal}`
      }
      headline={data.title}
      subtitle={data.subtitle}
      description={data.description}
      products={products}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorAffiliateItem;
